export function selectJourneyCheckpoint(record, local, totalSteps) {
  const localTime = Date.parse(local?.savedAt || "");
  const serverTime = Date.parse(record?.lastSavedAt || record?.updatedAt || "");
  const useLocal = Number.isFinite(localTime) &&
    (!record || !Number.isFinite(serverTime) || localTime > serverTime);
  const selected = useLocal ? local : record;
  let stage = Number(selected?.currentStage || 1);
  if (totalSteps === 10 && selected?.journeyData?.journeyVersion !== 2 && stage >= 8) stage = 8;
  return {
    currentStage: Number.isInteger(stage) ? Math.max(1, Math.min(totalSteps, stage)) : 1,
    journeyData: selected?.journeyData || {},
  };
}

export function advanceCompletedVerificationStages(stage, data, journeyVersion) {
  const completed = journeyVersion === 5 ? {
    1: data.selfieDone,
    4: data.kycDone,
    5: data.addressProofDone,
  } : {
    3: data.kycDone,
    4: data.addressProofDone,
    5: data.selfieDone,
  };
  while (completed[stage] === true) stage += 1;
  return stage;
}
